import { createStore } from 'effector-root'
import { DropdownItem } from '@/pages/common/types'
import { createFilter } from '@/pages/common/filter-dropdown/create-filter'
import { mapCoursesTypeFilter } from '@/pages/learning/learning-courses/constants'

export const courseTypeDropdownModule = createFilter()

export const $courseType = createStore<DropdownItem[]>(mapCoursesTypeFilter)
